var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"items":_vm.seconds,"headers":_vm.headers},scopedSlots:_vm._u([{key:"item.time",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.time(item.time))+" ")]}},{key:"item.latitude",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.decimalFix(item.latitude))+" ")]}},{key:"item.longitude",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.decimalFix(item.longitude))+" ")]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }